export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/decor-right.3c70156b-730c7a.png";